<template>
    <div class="w-100 m-0 d-flex justify-content-center">
        <div class="container-inputs p-3 m-0">
            <Breadcrumbs :breadcrumbs="breadcrumbs" />
            <h4 class="display-4 fw-normal text-white title">Nieuwe ziekmelding</h4>
            <hr/>
            <div class="w-100" id="newDisability" style="display: none;">
                <form id="disabilityForm" @submit.prevent="submit">
                    <p class="p-3 rounded-2 bg-info text-dark text-start small w-100 appear"><i class="fa fa-info-circle me-1"></i>
                        Meld je direct ziek via onderstaand formulier. De dag waarop je je ziekmeldt, geldt namelijk als je eerste ziektedag. Dat is ook de dag waarop de wachttijd van twee maanden ingaat. Je kunt je niet met terugwerkende kracht ziekmelden.
                    </p>

                    <p class="p-3 rounded-2 bg-warning text-dark text-start small w-100 appear"><i class="fa fa-exclamation me-1"></i>
                        Meld je wel pas ziek als je door ziekte (deels) niet meer kunt werken. Je kunt je niet ziekmelden met een datum in de toekomst. Voorwaarde voor ziekmelden is dat je in ieder geval gedeeltelijk niet aan het werk bent. Geef bij je ziekmelding aan welk percentage dit is.
                    </p>

                    <p class="p-3 rounded-2 bg-warning text-dark text-start small w-100 appear"><i class="fa fa-exclamation-triangle me-1"></i>
                        <b>Let op!</b> Je ontvangt direct na het toevoegen van je ziekmelding een automatische mail met triagevragen. Check hiertoe indien nodig ook je spam. Deze mail moet binnen 2 werkdagen beantwoord worden, anders wordt je ziekmelding niet in behandeling genomen.
                    </p>

                    <!-- Start ziektebeeld -->
                    <div class="d-flex">
                        <div class="w-100">
                            <h6 class="text-white">Start ziektebeeld</h6>
                        </div>
                        <div class="w-100 mb-3">
                            <h6 id="startDate" class="text-white fw-normal text-end">{{ today }}</h6>
                        </div>
                    </div>

                    <!-- Beschrijving -->
                    <div class="d-block appear w-100 mb-2">
                        <h6 class="text-white">Beschrijving</h6>
                        <textarea class="form-control" rows="4" placeholder="Beschrijf je ziekmelding hier" v-model="description"></textarea>
                    </div>

                    <!-- Behandeling bij arts -->
                    <h6 class="text-white">Ben je onder behandeling bij een arts?</h6>
                    <div class="d-flex ps-1">
                        <input type="radio" name="doctor" value="1" class="mb-3" v-model="treatmentByDoctor">
                        <p class="text-white ms-2 me-4">Ja</p>

                        <input type="radio" name="doctor" value="0" class="mb-3" v-model="treatmentByDoctor">
                        <p class="text-white ms-2">Nee</p>
                    </div>

                    <!-- Zelfde oorzaak eerdere ziekmelding? -->
                    <h6 class="text-white">Heeft deze ziekmelding dezelfde oorzaak als een eerdere ziekmelding?</h6>
                    <div class="d-flex ps-1">
                        <input type="radio" name="samesickness" value="1" class="mb-3" @change="() => toggleCauses(1)" v-model="sameSickness">
                        <p class="text-white ms-2 me-4">Ja</p>

                        <input type="radio" name="samesickness" value="0" class="mb-3" checked @change="() => toggleCauses(0)" v-model="sameSickness">
                        <p class="text-white ms-2">Nee</p>
                    </div>

                    <!-- Vorige oorzaken -->
                    <div id="previousCauses">
                        <div class="mb-3">
                            <h6 class="text-white">Vorige oorzaken</h6>
                            <select class="form-select" id="connectedDisability">
                                <option value="">-- Selecteer een ziekmelding --</option>
                                <option v-for="disability in previousDisabilites" :key="disability.id" :value="disability.id">
                                    {{ disability.created_at }} {{ disability.description }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <h6 class="text-white">Wanneer verwacht je weer te gaan werken?</h6>
                    <input type="date" id="expectedEndDate" class="form-control" v-model="expectedEndAt" >

                    <div class="d-block d-md-flex mt-3 appear">
                        <button type="submit" class="btn btn-primary"><i class="fa fa-save"></i> Ziekmelding toevoegen</button>
                    </div>
                </form>
            </div>

            <div class="w-100" id="newDisabilityNotAvailable" style="display: none">
                <div class="filler">
                    <p class="p-3 rounded-2 bg-warning text-dark text-start small w-100 appear"><i class="fa fa-exclamation me-1"></i>
                        <span id="disabilityText" class="fw-normal">Je hebt op dit moment al een lopende ziekmelding staan. Meld je eerst beter voordat je een nieuwe ziekmelding indient.</span>
                    </p>
                    <router-link to="/disability" class="btn btn-light"><i class="fa fa-arrow-left"></i>&nbsp;&nbsp;Terug naar Mijn gezondheid</router-link>
                    <div v-if="this.disabilities.length" @click="() => this.$router.push(`/disability/update/${this.disabilities[0].id}`)" class="btn btn-primary float-end">Naar ziekmelding&nbsp;&nbsp;<i class="fa fa-arrow-right"></i></div>
                </div>
            </div>
        </div>
    </div>
    <Modal v-for="modal in modals" :key="modal.title" :title="modal.title" :content="modal.content"
        :button_text="modal.button_text" :button_icon="modal.button_icon" :url="modal.url" :modal_type="modal.modal_type" :question_enum="modal.question_enum" :additional_class="modal.additional_class"
        @closeModal="closeModal" @sendDisability="sendDisability"/>
</template>

<style scoped>
h6 {
    font-weight: 800;
}

input[type="radio"] {
    transform: scale(1.5);
}

p {
    text-align: right;
}

.tl {
    text-align: left !important;
}

input::placeholder {
    color: rgba(0, 0, 0, 0.4);
}

hr {
    border-color: rgba(255, 255, 255, 0.5);
}

.back {
    color: #fff !important;
    opacity: 75%;
    font-size: 12px;
    text-align: left;
}

.bg-transparent {
    background-color: rgba(0, 0, 0, 0.3) !important;
}
</style>

<script>
import $ from 'jquery';
import Breadcrumbs from '@/components/BreadcrumbsComponent.vue';
import Modal from '@/components/ModalComponent.vue';
import { Breadcrumb, getCustomer, updateAppearanceKnab, isKnab } from '@/App.vue';
import { useToast } from 'vue-toastification';

export default {
    name: "personalia-component",
    components: {
        Breadcrumbs,
        Modal,
    },
    data() {
        return {
            breadcrumbs: [new Breadcrumb('/disability', "Mijn gezondheid"), new Breadcrumb("/disability/new", "Nieuwe ziekmelding")],
            today: this.convertDate(new Date()),
            previousDisabilites: [],
            expectedEndAt: null,
            treatmentByDoctor: 0,
            description: null,
            connectedDisability: null,
            modals: [],
            current_brand_id: undefined,
            dynamic: null,
            disabilities: [],
            active_participants: [],
            now: new Date(new Date().setHours(0,0,0,0)),
            sameSickness: false,
        }
    },
    methods: {
        convertDate(date) {
            let day, month, year;
            day = date.getDate();
            month = date.getMonth();
            year = date.getFullYear();
            return `${day < 10 ? "0" + day : day}-${(month + 1) < 10 ? "0" + (month + 1) : month + 1}-${year}`;
        },
        toggleCauses(display) {
            if(display)
                $("#previousCauses").show(400);
            else
                $("#previousCauses").hide(400);
        },
        async submit() {
            // Verzend ziekmelding naar de backend
            try {
                if(!this.description || this.description === '') {
                    const toast = useToast();
                    toast.error("Vul alsjeblieft een beschrijving in", {
                        icon: "fa fa-times"
                    });
                    return;
                }

                if(this.expectedEndAt && new Date(this.expectedEndAt).getTime() < new Date().getTime()) {
                    const toast = useToast();
                    toast.error("Vul alsjeblieft een datum in de toekomst in", {
                        icon: "fa fa-times"
                    });
                    return;
                }

                this.modals.push(this.$createModal("Ziekmelding versturen", "Weet je zeker dat je deze ziekmelding wilt versturen?", "fa-check", "Ja", "/disability", this.$ModalType.Question, "sendDisability"));
            } catch(error) {
                console.log(error);
            }
        },
        async sendDisability() {
            $('#modalContainer .modal-idesign .btn.btn-primary.me-1').addClass('disabled');
            $('#modalContainer .modal-idesign .btn.btn-primary.me-1').find('i').addClass('fa-spinner fa-pulse').removeClass('fa-check');
            try {
                await this.$http.post('disabilities/add', {
                    "expected_end_at": this.expectedEndAt,
                    "under_treatment_by_a_doctor": this.treatmentByDoctor,
                    "description": this.description,
                    "connected_disability_id": $("#connectedDisability").find(":selected").val(),
                    "samesickness": this.sameSickness,
                })
                .then((response) => {
                    // Zet een timer om niet te snel naar de volgende route te gaan
                    if(response.data.errors) {
                        const toast = useToast();
                        toast.error(response.data.errors, {
                            icon: "fa fa-times"
                        });
                        $(".close").trigger('click');
                        return false;
                    }
                    this.$router.push(`/disability/confirmation/${response.data.id}`);
                });
            } catch(error) {
                console.log(error);
            }
        },
        closeModal() {
            this.modals[0].additional_class = 'disappear';
            setTimeout(() => {
                this.modals = [];
            }, 500);
        },
        async getDisabilities() {
            try {
                this.$http.get('disabilities')
                .then((response) => {
                    // Haal ziekmeldingen op om vorige oorzaken toe te voegen
                    response.data.data.forEach((element) => {
                        if(element.description) {
                            this.previousDisabilites.push(element);
                        }
                    });
                });
            } catch(error) {
                console.log(error);
            }
        },
        hasCurrentDisabilities() {
            let list = this.disabilities.filter(disability => (disability.end_at === null || new Date(disability.end_at) >= new Date()));
            return list.length > 0
        },
    },
    async mounted() {
        let customer = getCustomer();
        if(customer) {
            this.current_brand_id = customer.current_brand_id;
            if(isKnab()) {
                updateAppearanceKnab();
            }
        }

        this.$http.get('disabilities')
            .then((response) => {
                this.responseData = response.data;
                this.disabilities = this.responseData.data;
        });

        await this.$http.get('/participants/dynamic')
            .then((response) => {
                this.dynamic = response.data;

                this.active_participants = [];
                this.dynamic.participants.forEach(function(participant) {
                    const start_at = new Date(participant.start_at),
                        end_at = participant.end_at ? new Date(participant.end_at) : null;

                    if(start_at <= this.now && (!end_at || end_at >= this.now)) {
                        this.active_participants.push(participant)

                        this.dynamic.payment_subgroups.forEach(function(subgroup) {
                            if(subgroup.id == participant.subgroup_id) {
                                this.showPaymentParticipant = participant;
                                this.showPaymentSubgroup = subgroup;

                                if(participant.active_payout_requests.length) {
                                    participant.active_payout_requests.forEach(function(payout_request) {
                                        if(payout_request.type == 'payout_after_directdebit_sure' && payout_request.user_iban == 'retirement') {
                                            this.show_retirement_after_directdebit_amount = payout_request.amount;
                                        } else if(payout_request.type == 'payout_after_payment' && payout_request.user_iban == 'retirement') {
                                            this.show_retirement_after_payment_amount = payout_request.amount;
                                        } else if(payout_request.type == 'savings_during_payment' && payout_request.user_iban == null) {
                                            this.show_savings_during_payment_amount = payout_request.amount;
                                        }

                                    }.bind(this));
                                }
                            }
                        }.bind(this));

                        this.dynamic.aov_subgroups.forEach(function(subgroup) {
                            if(subgroup.id == participant.subgroup_id) {
                                this.showAovParticipant = participant;
                                this.showAovSubgroup = subgroup;
                            }
                        }.bind(this));

                        this.dynamic.cov_subgroups.forEach(function(subgroup) {
                            if(subgroup.id == participant.subgroup_id) {
                                this.showCovParticipant = participant;
                                this.showCovSubgroup = subgroup;
                            }
                        }.bind(this));
                    }
                }.bind(this));

                if(this.hasCurrentDisabilities() || !this.active_participants.length) {
                    $("#newDisabilityNotAvailable").show(400);
                    $("#newDisability").remove();
                } else {
                    $("#newDisability").show(400);
                    $("#newDisabilityNotAvailable").remove();
                }
            })

        $("#previousCauses").hide();

        $(".appear").hide();
        $(".appear").show(400);

        this.getDisabilities();

        if(!this.active_participants.length) {
            $("#disabilityText").text("Je kunt je niet ziek melden omdat je geen actieve deelname hebt. Stel eerst een productsamenstelling samen voordat je een ziekmelding indient.");
        }

        this.current_brand_id = getCustomer()?.current_brand_id;
    }
}
</script>